import {
  Board,
  BoardHeader,
  BoardSearchDetail,
  CancelButton,
  ColSpan1,
  ColSpan3,
  ColSpan4,
  ColTitle,
  Input,
  RelativeDiv,
  RowSpan,
  Span4,
  SubmitButton,
  SubmitContainer,
  ValidationScript
} from "../../assets/GlobalStyles";
import {VerticalRule} from "../../components/common/Common";
import {useAtom} from "jotai";
import React, {useCallback, useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useLocation, useNavigate} from "react-router-dom";
import {selMyInfo, selUserInfo, updateMyInfo, updateUser} from "../../services/platform/ManageUserAxios";
import {toast, ToastContainer} from "react-toastify";
import {ModalBody, ModalFooter, ModalHeader} from "../../components/modal/Modal";
import {modalController} from "../../store";
import styled from "styled-components";
import {
  accountInfoAtom,
  adminInfoAtom,
} from "./entity/common";
import {selectUserCategories} from "../../services/platform/ManageUserCategoryAxios";
import {tokenResultAtom} from "../login/entity";
import {multiAxiosCall} from "../../common/StringUtils";
import {DeleteUser} from "../../components/common/DeleteUser";

export function PwChange(props) {
  const {onSubmit, modalInfo,onSave,title} = props;
  const [, setModal] = useAtom(modalController)
  const handleModalComponent = () => {
    setModal({
      isShow: true,
      width: 460,
      modalComponent: () => {
        return (
          <PwChangeModal onSave={onSave} modalInfo={modalInfo} onSubmit={onSubmit}/>
        )
      }
    })
  }
  return <Button type={'button'} onClick={handleModalComponent}>{title}</Button>
}

function PwChangeModal(props) {
  const [showPassword, setShowPassword] = useState(false)
  const [accountInfoState, setAccountInfoState] = useAtom(props.modalInfo==='USER'? accountInfoAtom: adminInfoAtom)
  const {register, handleSubmit, watch, formState: {errors}} = useForm({
    mode: "onSubmit",
    defaultValues: accountInfoState
  })
  const onError = (error) => console.log(error)
  /**
   * 패스워드 입력
   * @param event
   */
  const handlePassword = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      password: event.target.value
    })
  }
  /**
   * 패스원드 컨펌
   * @param event
   */
  const handleConfirmPassword = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      confirmPassword: event.target.value
    })
  }
  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleSave = (data) => {
    props.onSave(data)
  }

  return (
    <div>
      <PasswordModalForm onSubmit={handleSubmit(handleSave, onError)}>
        <ModalHeader title={'비밀번호 변경'}/>
        <PasswordIntro>
          <PasswordIntroIcon aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <rect x="5" y="11" width="14" height="10" rx="2"/>
              <path d="M8 11V7a4 4 0 0 1 8 0v4"/>
            </svg>
          </PasswordIntroIcon>
          <div><strong>새 비밀번호를 설정해 주세요.</strong><span>영문 대·소문자, 숫자와 특수문자를 조합하여 안전한 비밀번호를 입력합니다.</span></div>
        </PasswordIntro>
        <PasswordModalBody>
          <RowSpan>
            <ColSpan4>
              <ColTitle><Span4>비밀번호</Span4></ColTitle>
              <RelativeDiv>
                <Input
                  maxLength={16}
                  type={showPassword ? 'text' : 'password'}
                  placeholder={'대문자, 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)'}
                  {...register("password", {
                    required: "비밀번호를 입력해주세요",
                    pattern: {
                      value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&]).{8,20}$/,
                      message: "비밀번호를 확인해주세요. 대문자, 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)"
                    }
                  })}
                  value={accountInfoState.password}
                  onChange={(e) => handlePassword(e)}
                />
                {errors.password && <ValidationScript>{errors.password?.message}</ValidationScript>}
              </RelativeDiv>
            </ColSpan4>
            <ColSpan1>
              <div onClick={handleShowPassword}>
                <EyeIcon aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/>
                    <circle cx="12" cy="12" r="2.75"/>
                    {!showPassword && <path d="m4 4 16 16"/>}
                  </svg>
                </EyeIcon>
                <span>{showPassword ? '가리기' : '보기'}</span>
              </div>
            </ColSpan1>
          </RowSpan>
          <RowSpan>
            <ColSpan3>
              <ColTitle><Span4>비밀번호 확인</Span4></ColTitle>
              <RelativeDiv>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder={'대문자, 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)'}
                  {...register("confirmPassword", {
                    required: "비밀번호를 입력해주세요",
                    validate: (value) => {
                      if (watch('password') !== value) {
                        return "입력하신 비밀번호가 맞는지 확인부탁드립니다."
                      }
                    }
                  })}
                  maxLength={16}
                  value={accountInfoState.confirmPassword}
                  onChange={(e) => handleConfirmPassword(e)}
                />
                {errors.confirmPassword && <ValidationScript style={{marginBottom: 5}}>{errors.confirmPassword?.message}</ValidationScript>}
              </RelativeDiv>
            </ColSpan3>
          </RowSpan>
          <PasswordGuide>8자 이상 16자 이하로 입력하고 영문 대·소문자, 숫자, 특수문자를 포함해 주세요.</PasswordGuide>
        </PasswordModalBody>
        <PasswordModalFooter>
          <PasswordCancel type="button" onClick={props.onSubmit}>취소</PasswordCancel>
          <SubmitButton type={"submit"} >변경</SubmitButton>
        </PasswordModalFooter>
      </PasswordModalForm>
    </div>
  )
}

export default function PlatformUserDetail() {
  const [isDeleteOpen,setIsDeleteOpen]=useState(false)
  const [userCategories, setUserCategories] = useState([])
  const [accountInfoState, setAccountInfoState] = useAtom(accountInfoAtom)
  const [tokenResultInfo, setTokenResultInfo] = useAtom(tokenResultAtom)
  const [, setModal] = useAtom(modalController)
  const {register, handleSubmit, reset, formState: {errors}} = useForm({
    mode: "onSubmit",
    defaultValues: accountInfoState
  })
  const onError = (error) => console.log(error)
  const navigate = useNavigate()
  const {state} = useLocation();

  useEffect(() => {
    selectUserCategories()
      .then(setUserCategories)
      .catch(() => setUserCategories([]))
  }, [])

  useEffect(() => {
    function callbackFunc(response) {
      const resInfo = {
        ...response[0],
        activeYn: response[0].status === 'NORMAL' ? 'Y' : 'N',
      };

      setAccountInfoState(resInfo);
      reset(resInfo);
    }

    multiAxiosCall(
        [
          tokenResultInfo.role === 'NORMAL'
              ? selMyInfo(tokenResultInfo.id)
              : selUserInfo(state?.id),
        ],
        callbackFunc
    );

    return () => {
      setModal({isShow: false});
    };
  }, [
    reset,
    setAccountInfoState,
    setModal,
    state?.id,
    tokenResultInfo.id,
    tokenResultInfo.role,
  ]);

  const onSubmit = useCallback(() => {
    function callbackFunc(response) {
      if (response[0]) {
        toast.success("수정 되었습니다.", {
          onClose: () => tokenResultInfo.role === 'NORMAL'
              ? navigate('/board/dashboard')
              : navigate('/board/platform'),
          autoClose: 100,
          delay: 0,
        });

        setTokenResultInfo({
          ...tokenResultInfo,
          name: accountInfoState.siteName,
        });
      } else {
        toast.warning("수정이 실패 하였습니다. 관리자한테 문의하세요");
      }
    }

    function callbackFuncDel(response) {
      if (response[0]) {
        toast.success("삭제 되었습니다.", {
          onClose: () => tokenResultInfo.role === 'NORMAL'
              ? navigate('/')
              : navigate('/board/platform'),
          autoClose: 100,
          delay: 0,
        });
      } else {
        toast.warning("삭제에 실패 하였습니다. 관리자한테 문의하세요");
      }
    }

    multiAxiosCall(
        [
          tokenResultInfo.role === 'NORMAL'
              ? updateMyInfo(accountInfoState)
              : updateUser(accountInfoState),
        ],
        accountInfoState.delYn === 'Y' ? callbackFuncDel : callbackFunc
    );
  }, [
    accountInfoState,
    navigate,
    setTokenResultInfo,
    tokenResultInfo,
  ]);

  useEffect(() => {
    if (accountInfoState.delYn === 'Y') {
      onSubmit();
    }
  }, [accountInfoState.delYn, onSubmit]);

   /**
   * 매체 명 입력
   * @param event
   */
  const handleMediaName = (event) => {
        setAccountInfoState({
          ...accountInfoState,
          siteName: event.target.value
        })
      }
  /**
   * 매체 사이트 URL 입력
   * @param event
   */
  const handleMediaSiteUrl = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      siteUrl: event.target.value
    })
  }
  /**
   * 사용자 매체 카테고리 선택
   * @param event
   */
  const handleCategory = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      categoryId: event.target.value || null,
    })
  }
  /**
   * 담당자명 입력
   * @param event
   */
  const handleManagerName = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      managerName1: event.target.value
    })
  }
  /**
   * 담당자 연락처 입력
   * @param event
   */
  const handleManagerPhone = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      managerPhone1: event.target.value
    })
  }
  /**
   * 담당자 이메일 입력
   * @param event
   */
  const handleManagerEmail = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      managerEmail1: event.target.value
    })
  }

  /**
   * 담당자 2 이름 입력
   * @param event
   */
  const handleSecondManagerName = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      managerName2: event.target.value
    })
  }

  /**
   * 담당자 2 연락처 입력
   * @param event
   */
  const handleSecondManagerPhone = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      managerPhone2: event.target.value
    })
  }

  /**
   * 담당자 2 이메일 입력
   * @param event
   */
  const handleSecondManagerEmail = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      managerEmail2: event.target.value
    })
  }
  /**
   * 사용여부
   * @param activeYn
   */
  const handleActiveYn = (activeYn) => {
    setAccountInfoState({
      ...accountInfoState,
      activeYn: activeYn
    })
  }
  /**
   * 사용자 삭제
   * @param delYn
   */
  const handleDelYn = (delYn) => {
    setAccountInfoState({
      ...accountInfoState,
      delYn: delYn
    })
  }

  const handleSavePassword = (data) =>{

    function callbackFunc(response) {
      if (response[0]) {
        toast.success("수정 되었습니다.", {onClose:() => {
          setModal({
            isShow: false,
            modalComponent: null
          })
        }})
      } else {
        toast.warning("수정이 실패 하였습니다. 관리자한테 문의하세요")
      }
    }
    multiAxiosCall([tokenResultInfo.role === 'NORMAL' ? updateMyInfo(data) : updateUser(data)], callbackFunc)
  }

  const onModalPw = () => {
    setModal({
      isShow: false,
      modalComponent: null
    })
  }
  const selectedCategory = userCategories.find(
    category => String(category.id) === String(accountInfoState.categoryId)
      || category.value === accountInfoState.category
  )

  return (
    <>
      <UserDetailPage>
      <DetailHero>
        <HeroText>
          <HeroEyebrow>{tokenResultInfo.role === "NORMAL" ? "MY PROFILE" : "USER DETAIL"}</HeroEyebrow>
          <HeroTitle>{tokenResultInfo.role === "NORMAL" ? "내 계정 정보를 관리합니다." : "사용자 정보를 확인하고 수정해 주세요."}</HeroTitle>
          <HeroDescription>{tokenResultInfo.role === "NORMAL" ? "매체 정보와 담당자 연락처를 확인하고 최신 정보로 관리해 주세요." : "계정 기본 정보부터 매체와 담당자 정보까지 한 화면에서 관리합니다."}</HeroDescription>
        </HeroText>
        <HeroMetrics>
          <HeroMetric><span>계정 상태</span><MetricValue $active={accountInfoState.activeYn === "Y"}>{accountInfoState.activeYn === "Y" ? "활성화" : "비활성화"}</MetricValue></HeroMetric>
          <HeroMetric><span>매체 구분</span><strong>{accountInfoState.mediaType === "DIRECT" ? "매체사" : "대행사"}</strong></HeroMetric>
          <HeroMetric><span>아이디</span><strong title={accountInfoState.username}>{accountInfoState.username || "-"}</strong></HeroMetric>
          <HeroMetric><span>매체명</span><strong title={accountInfoState.siteName}>{accountInfoState.siteName || "-"}</strong></HeroMetric>
        </HeroMetrics>
      </DetailHero>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <Board className="basic-card">
          <BoardHeader>
            <CardHeaderTitle>기본 정보</CardHeaderTitle>
            <CardHeaderDescription>계정 상태와 매체 및 담당자 정보를 확인하고 수정합니다.</CardHeaderDescription>
          </BoardHeader>
          <BoardSearchDetail>
            {tokenResultInfo.role !== 'NORMAL' &&
              <RowSpan>
                <ColSpan4>
                  <ColTitle><Span4>활성화 여부</Span4></ColTitle>
                  <ColSpan1>
                    <input type={'radio'}
                           id={'use'}
                           name={'useManager'}
                           checked={accountInfoState.activeYn === 'Y' ? true : false}
                           onChange={() => handleActiveYn('Y')}/>
                    <label htmlFor={'use'}>활성</label>
                    <input type={'radio'}
                           id={'unuse'}
                           name={'useManager'}
                           checked={accountInfoState.activeYn === 'Y' ? false : true}
                           onChange={() => handleActiveYn('N')}/>
                    <label htmlFor={'unuse'}>비활성</label>
                  </ColSpan1>
                </ColSpan4>
              </RowSpan>
            }
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>매체구분</Span4></ColTitle>
                <div>{(accountInfoState.mediaType === 'DIRECT') ? '매체사' : '대행사'}</div>
              </ColSpan3>
            </RowSpan>
            <RowSpan className="account-id-row">
              <ColSpan3>
                <ColTitle><Span4>아이디</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                    type={'text'}
                    placeholder={'아이디를 입력해주세요'}
                    value={accountInfoState.username || ""}
                    readOnly={true}
                  />
                </RelativeDiv>

              </ColSpan3>
              <PwChange title={'비밀번호 변경'} modalInfo={'USER'} onSave={handleSavePassword} onSubmit={onModalPw}/>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>매체명</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                    type={'text'}
                    placeholder={'매체명을 입력해주세요'}
                    value={accountInfoState.siteName || ""}
                    onChange={(e) => handleMediaName(e)}
                  />
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>카테고리</Span4></ColTitle>
                <RelativeDiv>
                  <CategorySelect
                    value={selectedCategory?.id || ""}
                    onChange={handleCategory}
                  >
                    <option value="">카테고리를 선택해 주세요.</option>
                    {userCategories.map(category => (
                      <option key={category.id || category.value} value={category.id}>
                        {category.label}
                      </option>
                    ))}
                  </CategorySelect>
                  {selectedCategory && (
                    <CategoryGuide>
                      <strong>{selectedCategory.description}</strong>
                      <span>포함 매체: {selectedCategory.examples}</span>
                    </CategoryGuide>
                  )}
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>매체 url</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                    type={'text'}
                    placeholder={'매체 사이트 정보를 입력해주세요'}
                    {...register("siteUrl", {
                      required: "매체 사이트 정보를 입력해주세요",
                    })}
                    value={accountInfoState.siteUrl || ""}
                    onChange={(e) => handleMediaSiteUrl(e)}
                  />
                  {errors.siteUrl && <ValidationScript>{errors.siteUrl?.message}</ValidationScript>}
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
          </BoardSearchDetail>
          <VerticalRule style={{marginTop: 20, backgroundColor: "#eeeeee"}}/>
        </Board>
        <Board className="manager-card manager-card-primary">
          <BoardHeader>
            <CardHeaderTitle>담당자 정보 1</CardHeaderTitle>
            <CardHeaderDescription>필수 담당자의 이름과 연락처, 이메일 정보를 관리합니다.</CardHeaderDescription>
          </BoardHeader>
          <BoardSearchDetail>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>담당자명</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                    type={'text'}
                    placeholder={'담당자 명을 입력해주세요'}
                    {...register("managerName1", {
                      required: "담당자 명을 입력해주세요",
                    })}
                    value={accountInfoState.managerName1 || ""}
                    onChange={(e) => handleManagerName(e)}
                  />
                  {errors.managerName1 && <ValidationScript>{errors.managerName1?.message}</ValidationScript>}
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>담당자 연락처</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                    type={'text'}
                    placeholder={'연락처를 입력해주세요.'}
                    {...register("managerPhone1", {
                      required: "담당자 연락처를 입력해주세요.",
                      pattern: {
                        value: /^[0-9-]+$/g,
                        message: "연락처를 형식을 확인해주세요"
                      },
                    })}
                    value={accountInfoState.managerPhone1 || ""}
                    onChange={(e) => handleManagerPhone(e)}
                  />
                  {errors.managerPhone1 && <ValidationScript>{errors.managerPhone1?.message}</ValidationScript>}
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>담당자 이메일</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                    type={'text'}
                    placeholder={'이메일을 입력해주세요.'}
                    {...register("managerEmail1", {
                      required: "담당자 이메일을 입력해주세요.",
                    })}
                    value={accountInfoState.managerEmail1 || ""}
                    onChange={(e) => handleManagerEmail(e)}
                  />
                  {errors.managerEmail1 && <ValidationScript>{errors.managerEmail1?.message}</ValidationScript>}
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
          </BoardSearchDetail>
          <VerticalRule style={{marginTop: 20, backgroundColor: "#eeeeee"}}/>
        </Board>
        <Board className="manager-card manager-card-secondary">
          <BoardHeader>
            <CardHeaderTitle>담당자 정보 2</CardHeaderTitle>
            <CardHeaderDescription>추가 담당자 정보는 필요한 경우 선택하여 입력합니다.</CardHeaderDescription>
          </BoardHeader>
          <BoardSearchDetail>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>담당자명</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                    type={'text'}
                    placeholder={'담당자 명을 입력해주세요'}
                    value={accountInfoState.managerName2 || ""}
                    onChange={(e) => handleSecondManagerName(e)}
                  />
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>담당자 연락처</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                    type={'text'}
                    placeholder={'연락처를 입력해주세요.'}
                    value={accountInfoState.managerPhone2 || ""}
                    onChange={(e) => handleSecondManagerPhone(e)}
                  />
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>담당자 이메일</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                    type={'text'}
                    placeholder={'이메일을 입력해주세요.'}
                    value={accountInfoState.managerEmail2 || ""}
                    onChange={(e) => handleSecondManagerEmail(e)}
                  />
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
          </BoardSearchDetail>
          <VerticalRule style={{marginTop: 20, backgroundColor: "#eeeeee"}}/>
        </Board>
        { tokenResultInfo.role === 'SUPER_ADMIN' &&
          <Board className="delete-card">
            <DeleteToggle type="button" $open={isDeleteOpen} onClick={()=>setIsDeleteOpen(open=>!open)} aria-expanded={isDeleteOpen}>
              <div><strong>계정 삭제</strong><span>삭제한 계정은 복구할 수 없으므로 신중하게 진행해 주세요.</span></div>
              <DeleteArrow $open={isDeleteOpen}>⌄</DeleteArrow>
            </DeleteToggle>
            {isDeleteOpen && <BoardSearchDetail>
              <DeleteWarning>
                <DeleteWarningIcon aria-hidden="true">!</DeleteWarningIcon>
                <DeleteWarningContent>
                  <strong>삭제 후 복구할 수 없습니다.</strong>
                  <span>계정을 삭제하면 개인정보와 서비스 이용 기록이 함께 영구 삭제됩니다. 삭제할 계정을 다시 확인해 주세요.</span>
                </DeleteWarningContent>
                <DeleteWarningAction>
                  <span>삭제할 계정과 관련 데이터를 확인한 후 진행해 주세요.</span>
                  <DeleteUser title={"삭제하기"} onSubmit={handleDelYn} btnStyle={'SearchUser'}/>
                </DeleteWarningAction>
              </DeleteWarning>
            </BoardSearchDetail>}
          </Board>
        }
        <SubmitContainer>
          <ActionGuide>
            <strong>{tokenResultInfo.role === "NORMAL" ? "마이페이지 설정" : "사용자 정보 설정"}</strong>
            <span>변경한 정보를 확인한 뒤 수정 버튼을 눌러 저장해 주세요.</span>
          </ActionGuide>
          <ActionButtons>
            <CancelButton type="button" onClick={() => navigate(tokenResultInfo.role === "NORMAL" ? '/board/dashboard' : '/board/platform')}>{tokenResultInfo.role === "NORMAL" ? "취소" : "목록"}</CancelButton>
            <SubmitButton type="submit">수정</SubmitButton>
          </ActionButtons>
        </SubmitContainer>
      </form>
      </UserDetailPage>
      <ToastContainer position="top-center"
                      autoClose={1500}
                      hideProgressBar
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      limit={1}
                      style={{zIndex: 9999999}}/>
    </>
  )
}

const PasswordModalForm=styled.form`
  overflow:hidden;border-radius:12px;background:var(--color-surface);
`;
const PasswordIntro=styled.div`
  display:flex;align-items:center;gap:12px;margin:18px 22px 0;padding:15px 17px;
  border:1px solid #dbe7f5;border-radius:9px;background:#f7faff;
  strong,span{display:block;}strong{color:var(--color-text-strong);font-size: var(--font-size-15);font-weight:750;}
  span{margin-top:4px;color:var(--color-text-muted);font-size: var(--font-size-11);line-height:1.5;}
`;
const PasswordIntroIcon=styled.span`
  display:inline-flex;width:38px;height:38px;flex:0 0 38px;align-items:center;justify-content:center;
  border-radius:9px;background:#e4efff;color:var(--color-primary-strong);
  svg{width:19px;height:19px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;}
`;
const EyeIcon=styled.span`
  display:inline-flex!important;width:18px!important;height:18px!important;align-items:center;justify-content:center;
  margin:0!important;background:none!important;border:0!important;border-radius:0!important;
  svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round;}
`;
const PasswordModalBody=styled(ModalBody)`
  display:flex;flex-direction:column;gap:14px;padding:20px 22px 24px!important;background:var(--color-surface);

  ${RowSpan}{
    position:relative;display:block!important;min-width:0;margin:0!important;padding:18px!important;
    border:1px solid #e3e8ee;border-radius:10px;background:#fafbfc;
  }
  ${ColSpan3},${ColSpan4}{
    display:flex!important;width:100%!important;min-width:0;align-items:stretch!important;flex-direction:column;gap:8px!important;
  }
  ${ColTitle}{width:100%;padding:0!important;color:#34404d;font-size: var(--font-size-13);font-weight:750;}
  ${ColTitle} span{width:auto!important;}
  ${RelativeDiv}{width:100%!important;}
  ${Input}{
    width:100%;height:44px;padding:0 44px 0 13px;border:1px solid #d8e0e8!important;border-radius:8px!important;
    background:var(--color-surface);color:#333;font-size: var(--font-size-13);transition:border-color .15s ease,box-shadow .15s ease;
  }
  ${RowSpan} + ${RowSpan} ${Input}{padding-right:13px;}
  ${Input}:hover{border-color:#a9c9ee!important;}
  ${Input}:focus{border-color:var(--color-primary)!important;box-shadow:0 0 0 3px rgba(59,130,246,.1)!important;}
  ${ColSpan1}{
    position:absolute!important;top:47px;right:24px;width:32px!important;height:32px;z-index:3;
    > div{display:inline-flex;width:32px;height:32px;align-items:center;justify-content:center;padding:0;border:0;border-radius:6px;background:transparent;color:#7c8794;cursor:pointer;}
    > div:hover{background:var(--color-primary-soft);color:var(--color-primary-strong);}
    > div > span:last-child{display:none!important;}
  }
  ${ValidationScript}{position:static!important;margin-top:6px!important;color:var(--color-danger-strong);font-size: var(--font-size-11)!important;}
  @media(max-width:640px){
    ${ColSpan1}{top:47px;right:24px;}
  }
`;
const PasswordGuide=styled.p`
  margin:0;padding:12px 14px;border-radius:7px;color:#7f8994;font-size: var(--font-size-11);line-height:1.55;
`;
const PasswordModalFooter=styled(ModalFooter)`
  display:flex!important;align-items:center!important;justify-content:flex-end!important;gap:8px;padding:16px 22px!important;
  border-top:1px solid var(--color-divider)!important;background:#f9fafb!important;
  ${SubmitButton}{
    width:auto!important;min-width:118px!important;height:42px!important;margin:0!important;padding:0 20px!important;
    border:1px solid var(--color-primary-strong)!important;border-radius:7px!important;background:var(--color-primary-strong)!important;color:var(--color-surface)!important;font-size: var(--font-size-13)!important;font-weight:700!important;
  }
  ${SubmitButton}:hover{background:var(--color-primary-dark)!important;}
`;
const PasswordCancel=styled.button`
  min-width:88px;height:42px;padding:0 17px;border:1px solid #cfd7df;border-radius:7px;
  background:var(--color-surface);color:#68717c;font-size: var(--font-size-13);font-weight:650;cursor:pointer;
  &:hover{border-color:#aeb8c2;background:#f5f7f9;color:#39434d;}
`;
const Button = styled.button`
  display:inline-flex;
  width:auto;
  min-width:112px;
  height:42px;
  align-items:center;
  justify-content:center;
  padding:0 16px;
  border:1px solid var(--color-primary-border);
  border-radius:8px;
  background-color:var(--color-primary-soft);
  color:var(--color-primary-strong);
  font-size: var(--font-size-13);
  font-weight:700;
  cursor: pointer;
  transition:background .15s ease,border-color .15s ease,color .15s ease,box-shadow .15s ease;

  &:hover {
    border-color:var(--color-primary-focus);
    background-color:var(--color-primary-muted);
    color:var(--color-primary-dark);
  }
  &:focus-visible{outline:0;box-shadow:0 0 0 3px rgba(59,130,246,.16);}
`
const DetailHero=styled.section`
  position:relative;display:grid;grid-template-columns:minmax(240px,.8fr) minmax(0,1.6fr);
  align-items:center;gap:24px;overflow:hidden;margin-bottom:16px;padding:24px;
  border:1px solid #dce7f4;border-radius:12px;background:linear-gradient(135deg,#f7faff 0%,var(--color-surface) 62%);
  box-shadow:0 7px 22px rgba(30,58,138,.055);
  &::before{position:absolute;top:0;left:0;width:100%;height:4px;background:var(--color-primary);content:"";}
  @media(max-width:900px){grid-template-columns:1fr;}
`;
const HeroText=styled.div``;
const HeroEyebrow=styled.div`margin-bottom:7px;color:var(--color-primary);font-size: var(--font-size-11);font-weight:800;letter-spacing:.14em;`;
const HeroTitle=styled.h2`margin:0;color:#20242b;font-size: var(--font-size-22);font-weight:750;letter-spacing:-.025em;`;
const HeroDescription=styled.p`margin:8px 0 0;color:#7f8994;font-size: var(--font-size-12);line-height:1.6;`;
const HeroMetrics=styled.div`display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px;@media(max-width:640px){grid-template-columns:repeat(2,1fr);}`;
const HeroMetric=styled.div`
  min-width:0;padding:13px 14px;border:1px solid #e3eaf2;border-radius:9px;background:rgba(255,255,255,.92);
  span,strong{display:block;}span{margin-bottom:6px;color:#8b95a0;font-size: var(--font-size-11);}
  strong{overflow:hidden;color:#34404d;font-size: var(--font-size-13);font-weight:750;text-overflow:ellipsis;white-space:nowrap;}
`;
const MetricValue=styled.strong`color:${({$active})=>$active?"#16845b":"var(--color-danger-strong)"}!important;`;
const CategorySelect=styled.select`
  width:100%;height:42px;box-sizing:border-box;padding:0 38px 0 12px;
  border:1px solid #dfe3e7;border-radius:8px;background:var(--color-surface);
  color:#333;font-size:var(--font-size-13);cursor:pointer;
  &:hover{border-color:var(--color-primary-border);}
  &:focus{border-color:var(--color-primary);outline:0;box-shadow:0 0 0 3px rgba(59,130,246,.1);}
`;
const CategoryGuide=styled.div`
  margin-top:8px;padding:10px 12px;border:1px solid var(--color-primary-border);
  border-radius:8px;background:var(--color-primary-soft);line-height:1.5;
  strong,span{display:block;}
  strong{color:var(--color-primary-dark);font-size:var(--font-size-12);font-weight:700;}
  span{margin-top:3px;color:var(--color-text-muted);font-size:var(--font-size-11);}
`;
const UserDetailPage=styled.div`
  width:100%;

  form{display:grid;grid-template-columns:minmax(0,1.08fr) minmax(0,.92fr);grid-template-rows:auto auto;align-items:stretch;gap:16px;}

  ${Board}{
    width:100%!important;min-width:0!important;height:100%;box-sizing:border-box;overflow:hidden;
    align-self:stretch;margin:0!important;padding:0!important;border:1px solid var(--color-border)!important;
    border-radius:10px!important;background:var(--color-surface)!important;box-shadow:0 5px 18px rgba(31,41,55,.045);
  }

  .basic-card{grid-column:1;grid-row:1 / span 2;}
  .manager-card-primary{grid-column:2;grid-row:1;}
  .manager-card-secondary{grid-column:2;grid-row:2;}
  .delete-card{grid-column:1/-1;}

  ${BoardHeader}{
    display:flex!important;min-height:66px;box-sizing:border-box;align-items:center!important;
    justify-content:space-between!important;gap:20px!important;margin:0!important;padding:0 20px!important;
    border-bottom:1px solid var(--color-border)!important;background:linear-gradient(90deg,var(--color-surface) 0%,#fffaf6 100%)!important;
  }

  ${BoardHeader}::before{display:none!important;}

  ${BoardSearchDetail}{
    display:grid;grid-template-columns:1fr;gap:16px;
    width:100%;box-sizing:border-box;margin:0!important;padding:16px 20px!important;border:0!important;background:var(--color-surface)!important;
  }

  ${RowSpan}{
    display:grid!important;grid-template-columns:minmax(110px,140px) minmax(0,1fr);min-width:0;
    align-items:center!important;gap:12px!important;margin:0!important;padding:12px 0!important;
    //border-bottom:1px solid var(--color-divider);
  }
  ${RowSpan}:last-child{border-bottom:0;}

  ${ColSpan3},${ColSpan4}{
    display:grid!important;grid-column:1/-1;grid-template-columns:minmax(110px,140px) minmax(0,1fr);
    width:100%!important;min-width:0;align-items:center!important;gap:12px!important;
  }

  .account-id-row{grid-template-columns:minmax(110px,140px) minmax(0,1fr) auto!important;}
  .account-id-row ${ColSpan3}{display:contents!important;}
  .account-id-row > button{grid-column:3;white-space:nowrap;}

  ${ColTitle}{
    margin:0!important;padding:0!important;color:#444;font-size: var(--font-size-13);font-weight:700;
  }
  ${ColTitle} span{width:auto!important;}

  ${Input}{
    width:100%;height:42px;box-sizing:border-box;padding:0 12px;border:1px solid #dfe3e7!important;
    border-radius:8px!important;background:var(--color-surface);color:#333;font-size: var(--font-size-13);
  }

  ${Input}:hover{border-color:var(--color-primary-border)!important;}
  ${Input}:focus{border-color:var(--color-primary)!important;outline:0;box-shadow:0 0 0 3px rgba(59,130,246,.1)!important;}
  ${Input}[readonly]{background:#f5f7f9;color:#7c8794;}

  input[type="radio"]{position:absolute;width:1px;height:1px;overflow:hidden;opacity:0;}
  input[type="radio"] + label{
    display:inline-flex;min-width:78px;height:34px;align-items:center;justify-content:center;margin:0 6px 0 0;
    border:1px solid #dfe3e7;border-radius:17px;background:var(--color-surface);color:#7c8794;font-size: var(--font-size-12);font-weight:700;cursor:pointer;
  }
  input#use:checked + label{border-color:#9fd8bf;background:#ecf8f2;color:#16845b;}
  input#unuse:checked + label{border-color:#efaaaa;background:#fff1f1;color:var(--color-danger-strong);}

  form > div > div[style*="background-color"]{display:none;}
  .basic-card ${BoardSearchDetail},.manager-card ${BoardSearchDetail}{align-content:start;}

  ${SubmitContainer}{
    grid-column:1/-1;
    position:sticky;bottom:0;z-index:5;display:flex!important;align-items:center!important;justify-content:space-between!important;gap:16px;
    margin:4px 0 0!important;padding:16px 20px!important;border:1px solid var(--color-primary-border)!important;
    border-left:4px solid var(--color-primary)!important;border-radius:10px!important;background:#f7faff!important;
  }

  ${CancelButton},${SubmitButton}{
    width:auto!important;min-width:92px!important;height:40px!important;margin:0!important;padding:0 18px!important;
    border-radius:7px!important;font-size: var(--font-size-13)!important;font-weight:700!important;
  }

  ${SubmitButton}{border-color:var(--color-primary-strong)!important;background:var(--color-primary-strong)!important;color:var(--color-surface)!important;}

  @media(max-width:760px){
    form{grid-template-columns:1fr;}
    .basic-card,.manager-card-primary,.manager-card-secondary,.delete-card{grid-column:1;grid-row:auto;}
    ${BoardSearchDetail}{grid-template-columns:1fr;padding:16px!important;}
    ${RowSpan},${ColSpan3},${ColSpan4}{grid-template-columns:1fr!important;}
    .account-id-row{grid-template-columns:1fr!important;}
    .account-id-row ${ColSpan3}{display:grid!important;grid-template-columns:1fr!important;}
    .account-id-row > button{grid-column:1;width:100%;}
    ${SubmitContainer}{align-items:stretch!important;flex-direction:column;}
  }
`;
const ActionGuide=styled.div`
  min-width:0;text-align:left;
  strong,span{display:block;}strong{color:#2f3438;font-size: var(--font-size-14);font-weight:800;}
  span{margin-top:4px;color:#7f878e;font-size: var(--font-size-11);line-height:1.45;}
`;
const ActionButtons=styled.div`
  display:flex;flex:0 0 auto;align-items:center;gap:8px;
  @media(max-width:760px){width:100%;button{flex:1;}}
`;
const CardHeaderTitle=styled.strong`
  flex:0 0 auto;color:#20242b;font-size: var(--font-size-15);font-weight:750;white-space:nowrap;
`;
const CardHeaderDescription=styled.span`
  min-width:0;overflow:hidden;color:var(--color-text-muted);font-size: var(--font-size-11);font-weight:500;text-align:right;text-overflow:ellipsis;white-space:nowrap;
  @media(max-width:640px){white-space:normal;}
`;
const DeleteToggle=styled.button`
  display:flex;width:100%;min-height:66px;box-sizing:border-box;align-items:center;justify-content:space-between;gap:16px;
  padding:14px 20px;border:0;border-bottom:${({$open})=>$open?"1px solid #f2d5d5":"1px solid transparent"};
  background:var(--color-surface);color:inherit;text-align:left;cursor:pointer;
  strong,span{display:block;}strong{color:#2f3438;font-size: var(--font-size-17);font-weight:700;}
  span{margin-top:5px;color:#9a7b7b;font-size: var(--font-size-11);}
  &:hover{background:#fffafa;}
`;
const DeleteArrow=styled.span`
  display:inline-flex;color:var(--color-danger-strong);font-size: var(--font-size-22);transform:rotate(${({$open})=>$open?"180deg":"0deg"});
  transition:transform .18s ease;
`;
const DeleteWarning=styled.div`
  display:grid;grid-template-columns:40px minmax(0,1fr) minmax(210px,.55fr);align-items:center;gap:16px;
  width:100%;box-sizing:border-box;padding:18px;border:1px solid #f2c2c2;border-radius:9px;background:#fff3f3;
  @media(max-width:760px){grid-template-columns:40px 1fr;& > div:last-child{grid-column:1/-1;}}
`;
const DeleteWarningIcon=styled.span`
  display:inline-flex;width:38px;height:38px;align-items:center;justify-content:center;border-radius:50%;
  background:#d94b4b;color:var(--color-surface);font-size: var(--font-size-22);font-weight:800;
`;
const DeleteWarningContent=styled.div`
  min-width:0;strong,span{display:block;}strong{color:#bf3030;font-size: var(--font-size-14);font-weight:800;}
  span{margin-top:6px;color:#a65e5e;font-size: var(--font-size-11);line-height:1.55;}
`;
const DeleteWarningAction=styled.div`
  display:flex;align-items:flex-end;flex-direction:column;gap:9px;text-align:right;
  > span{color:#a65e5e;font-size: var(--font-size-11);line-height:1.45;}
  button{width:108px!important;height:38px!important;border-radius:7px!important;background:#cc4545!important;color:var(--color-surface)!important;font-size: var(--font-size-13)!important;font-weight:700!important;}
  button:hover{background:#b93636!important;}
  @media(max-width:760px){align-items:stretch;text-align:left;button{width:100%!important;}}
`;
